module.exports = __webpack_public_path__ + "img/result-detail-output-outright03.0cd1b24f.svg";